import React, { useMemo } from "react";
import { useSwarm } from "@lbs/swarm-client";
import { GameCard } from "@lbs/sportsbook";
import Config from "@skin_config";

import {
  getSwarmPopuplarLiveGamesQuery,
  getSwarmPopuplarPromotedGamesQuery,
  getSwarmPromotedGamesCountQuery,
} from "@common/helpers/requests/popularGames";
import { asyncWrapper } from "@common/hocs/asyncWrapper";
import { GetArrayGame } from "@common/helpers/util/swarmTreeDestructuring";

import HomeSectionTitle from "../sectionTitle";

import './style.scss';

const HomePopularGames = () => {
  const { game: gameCount } = useSwarm(getSwarmPromotedGamesCountQuery());

  const showPromoted = !!gameCount;

  const query = showPromoted
    ? getSwarmPopuplarPromotedGamesQuery()
    : getSwarmPopuplarLiveGamesQuery(Config.verticalHome.liveGamesCount || Config.home.liveGamesCount, false);

  const data = useSwarm(query);

  const gameList = useMemo(() => GetArrayGame(data.game), [data]);

  return (
    <div className="home-popular-games-wrp">
      <HomeSectionTitle title={showPromoted ? "Popular matches" : "Live matches"} />

      <div className="home-popular-games">
        {gameList.map((game) => (
          <GameCard goToGameOnEventClick key={game.id} game={game} />
        ))}
      </div>
    </div>
  );
};

export default asyncWrapper(HomePopularGames);
